import { ICourse } from '../../../../../interfaces/ICourse'
import * as React from 'react'
import { Button, ButtonGroup, Paper, Typography } from '@mui/material'
import { ISchool } from '../../../../../interfaces/school.interface'
import PaymentForCourseButton from '../../../../PaymentComponent/PaymentForCourseButton'
import { IUserDetails } from '../../../../../interfaces/user.interface'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import { showCoursePayButtonOnCourseDetailsPage } from '@/services/utils'

export default function StudentRegisteredActionComponent(props: {
  course_details: ICourse
  user_details: IUserDetails
  schoolDetailsFromCourse: ISchool
  courseStudentStatus: string
  reloadStudentCourseStatus: (goToClass?: boolean) => void
  openPaymentDetails: boolean
}) {
  const [showPaymentButtonSetting] = React.useState(
    showCoursePayButtonOnCourseDetailsPage({
      courseDetails: props.course_details,
    }),
  )
  const class_url = `/courses/content/${props.course_details._id}`

  // Remove Go to live class button
  // const [
  //   secondaryActionsAnchorEl,
  //   setSecondaryActionsAnchorEl,
  // ] = React.useState(null);

  // const handleSecondaryActionsClick = (event: any) => {
  //   setSecondaryActionsAnchorEl(event.currentTarget);
  // };

  // const handleSecondaryActionsClose = () => {
  //   setSecondaryActionsAnchorEl(null);
  // };

  return (
    <React.Fragment>
      <div style={{ width: '100%', padding: '10px 0px' }}>
        {props.courseStudentStatus === 'unapproved' && (
          <>
            {Boolean(props.course_details?.price) &&
              !props.course_details.disable_direct_registration &&
              showPaymentButtonSetting && (
                <Paper
                  variant={'outlined'}
                  style={{
                    backgroundColor: 'inherit',
                    border: 'none',
                    marginBottom: '10px',
                    marginTop: '20px',
                  }}
                >
                  <div>
                    <Typography
                      style={{ color: '#fff' }}
                      variant={'body2'}
                      align={'center'}
                    >
                      Your registration was successful however <br /> your
                      access is currently restricted. You will get full access
                      to the course after payment
                    </Typography>

                    <PaymentForCourseButton
                      buttonVariant={'outlined'}
                      courseDetails={props.course_details}
                      school={props.schoolDetailsFromCourse}
                      user_details={props.user_details}
                      openDialogByDefault={props.openPaymentDetails}
                      onCloseDialog={() => {
                        props.reloadStudentCourseStatus(true)
                      }}
                    />
                  </div>
                </Paper>
              )}
          </>
        )}
        <ButtonGroup
          fullWidth={true}
          size={'large'}
          variant={'contained'}
          color={'primary'}
          disableElevation={true}
          disabled={props.course_details?.isComingSoon}
          style={{
            height: '50px',
          }}
        >
          <Button href={class_url}>
            <b>Open class</b>{' '}
            <ArrowForwardIcon style={{ marginRight: '5px' }} />
          </Button>
        </ButtonGroup>
      </div>
      {props.courseStudentStatus === 'approved' && (
        <div>
          <Button
            fullWidth={true}
            href={'/dashboard'}
            size={'large'}
            variant={'outlined'}
            // style={{ color: '#fff' }}
          >
            Go to your dashboard
          </Button>
        </div>
      )}
      {props.course_details?.isComingSoon && (
        <div>
          <Typography align={'center'} color={'secondary'}>
            <i> Course is coming soon...</i>
          </Typography>
        </div>
      )}
    </React.Fragment>
  )
}
